export const triggerSubmit = (formElement) => {
    const event = new CustomEvent('customSubmit', { cancelable: true });
    formElement.dispatchEvent(event);
};
